export default function NotFound() {
  return (
    <div className="h-screen flex items-center justify-center overflow-hidden">
      <h1 className="text-[320px] text-center font-medium mt-6">404</h1>
    </div>
  );
}
